import { IAccountTag, ResourceAutoCompleteViewModelType } from '@ViewModels';
import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { ViewModelTypeAutocomplete } from '../../../../containers/Settings/PhoneNumbers/components/ViewModelTypeAutocomplete';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (item: string) => void;
	className?: string;
	autoCompleteInputWrapperStyles?: StyleDeclarationValue[];
}

export const CompanyTagsSelect: React.FC<IProps> = ({ onChange, className, autoCompleteInputWrapperStyles }) => {
	const [selectedItem, selectItem] = useState(null);
	const handleSelection = (value: IAccountTag) => {
		onChange(value?.name);

		selectItem(value?.name);
	};
	return (
		<ViewModelTypeAutocomplete<IAccountTag>
			className={className || `company-tags-select ${css(styleSheet.autocomplete)}`}
			placeholder={selectedItem ? 'Tag: ' + selectedItem : 'Filter by tag'}
			model={ResourceAutoCompleteViewModelType.AccountTag}
			onChange={handleSelection}
			autoCompleteInputWrapperStyles={autoCompleteInputWrapperStyles}
		/>
	);
};
